package diana.soleil.design.iraniancanadienbazzar.core.model

import kotlinx.serialization.Serializable

/**
 * Paid placement boost for a business. [active] gates whether the listing is eligible for sponsored
 * slots; [scope] is null on the free plan. Windows ([startsAt]/[endsAt]) are validated server-side.
 */
@Serializable
data class Sponsorship(
    val active: Boolean = false,
    val plan: String = "free",
    val scope: SponsorshipScope? = null,
    val startsAt: String? = null,
    val endsAt: String? = null,
)
